import { API } from '@/config';
import { findPathWithAfterLogin } from './helpers';
import authorizationModule from './authorizationModule';
import setRouter from './setRouter';

const authDefaultOptions = {
  endpoints: {
    login: '/authorization/loginUserToPlatform',
    logout: '/authorization/logoutUserFromPlatform',
    session: '/authorization/checkIfUserSessionExists',
    registration: '/authorization/registerToPlatform',
  },
};

export default {
  install(Vue, options, store, router) {
    // first register a new module
    store.registerModule('authorization', authorizationModule);

    // set options
    const __options__ = { ...authDefaultOptions, ...options };
    const pathAfterLogin = findPathWithAfterLogin(router.options.routes);

    // Define global methods for handling authorization
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$auth = {
      loginToPlatform: async (params) => {
        API.removeResponseInterceptor();
        const url = await store.dispatch('authorization/loginToPlatform', {
          endpoint: __options__.endpoints.login,
          params,
        });
        window.location.href = url;
      },
      changePasswordToPlatform: async (params) => {
        API.removeResponseInterceptor();
        const url = await store.dispatch('authorization/changePasswordToPlatform', {
          endpoint: __options__.endpoints.changePassword,
          params,
        });
        window.location.href = url;
      },
      logoutFromPlatform: async () => {
        await store.dispatch('authorization/logoutFromPlatform', {
          endpoint: __options__.endpoints.logout,
        });
        router.push({ path: '/' });
      },
      checkIfUserSessionExists: async () => {
        await store.dispatch('authorization/checkIfUserSessionExists', {
          endpoint: __options__.endpoints.session,
        });
      },
      registerToPlatform: async (params) => {
        const url = await store.dispatch('authorization/registerToPlatform', {
          endpoint: __options__.endpoints.registration,
          params,
        });
        window.location.href = url;
      },
    };

    __options__.pathAfterLogin = pathAfterLogin;
    setRouter(router, API, store, __options__);
  },
};
